module.exports = __webpack_public_path__ + "2b010cb741cb87dd18c85e7197358d9e.MP3";